/**
 *
 */
(function ($) {
  Drupal.behaviors.rmccCalTree = {
    attach(context, settings) {
      if (!$('.js-cal-tree').length) {
        return false;
      }
      this.funkifyCursor(context, settings);
      this.toggleCalResults(context, settings);
      this.searchKeyPress(context, settings);

      var $singleResult = $('.single-result', context);
      if ($singleResult.length > 0) {
        var $starName = $singleResult.text();

        if ($('.personal-message', context).length > 0) {
          var isStarMessage = true;
          var $starMessage = $('.personal-message', context).text();
        }

        $('.cal-tree__tree').removeClass('found');
        $('.found .cal-tree__tree-wrapper').removeClass('sparkle');
        $('.cal-tree__star-found').removeClass('found');
        $('.found-star-alert').removeClass('found');
        $('.cal-tree__star-message').removeClass('found').empty();

        window.setTimeout(function() {
          $('.cal-tree__more-results').removeClass('show');

          // Star found
          $('.found-star-alert').addClass('found');
          window.setTimeout(function() {
            $('.js-cal-tree').addClass('found');
            $('.cal-tree__tree').addClass('found');
          }, 200);
          window.setTimeout(function() {
            $('.cal-tree__star-found')
              .addClass('found')
              .find('span')
              .empty()
              .text($starName);
            if (isStarMessage) {
              $('.cal-tree__star-message')
                .addClass('found')
                .text($starMessage);
            }
          }, 1500);
        });
        $('html, body').animate({
          scrollTop: $('.cal-tree__star-found').offset().top - 100
        }, 500);
      }
      $('.js-toggle-star-found').on('click', function(e) {
        var $starName = $(e.currentTarget).text();
        var $starId = $(e.currentTarget).attr('id');
        e.preventDefault();
        $('#edit-search', context).val($starName);
        $('.search-input-id', context).val($starId);
        $('#edit-submit', context).trigger('mousedown');
      });
    },

    toggleCalResults: function(context) {
      var $toggleButton = $('.js-toggle-cal-results', context);
      var $moreResults = $('.cal-tree__more-results');

      $toggleButton.on('click', function(e) {
        e.preventDefault();
        $moreResults.addClass('show');
        $('html, body').animate({
          scrollTop: $moreResults.offset().top
        }, 1000);
      });

      var $toggleReset = $('.js-cal-tree-reset', context);
      $toggleReset.on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $('.cal-tree__form').offset().top
        }, 500, function() {
          $moreResults.removeClass('show');
        });
      });
    },

    funkifyCursor: function (context) {

      var $calTree = $('.js-cal-tree', context);

      if (!$calTree.length) {
        return false;
      }

      var starTrail = {};

      starTrail.size = 10;
      starTrail.jitter = 50;
      starTrail.zindex = 5;
      starTrail.life = 1000;

      $calTree.on('mousemove', function (e) {
        var animate = function (i) {
          var j = (1 - i) * starTrail.jitter;
          var star = document.createElement('div');
          var size = Math.ceil(Math.random() * starTrail.size * i);
          var sizepx = size + 'px';
          $(star).css({
            "position": 'fixed',
            "top": e.clientY +
              Math.round((Math.random() - 0.5) * j - size / 2) + 'px',
            "left": e.clientX +
              Math.round((Math.random() - 0.5) * j - size / 2) + 'px',
            "width": sizepx,
            "height": sizepx,
            "color": 'white',
            "font-size": 12 + 'px',
            "opacity": Math.random() * 0.95,
            "pointerEvents": 'none',
            "zIndex": starTrail.zindex +
              Math.round(5 * (Math.random() - 0.5))
          })
            .text('☆');
          $('body').append(star);
          window.setTimeout(function () {
            document.body.removeChild(star);
          }, Math.round(Math.random() * i * starTrail.life));
        };
        for (var i = 0.2; i <= 1.0; i += 2) {
          animate(i);
        }
      });
    },

    searchKeyPress: function (context) {
      $('#edit-search', context).keypress(function(e) {
        if (e.which == 13) {
          $('#edit-submit', context).mousedown();
          e.preventDefault();
        }
      });
    }
  };
})(jQuery);


